import GenericModel from './generic-model';
import { RoleName } from './role-name';

export class Role extends GenericModel {
  name: RoleName;

  constructor(name?: RoleName) {
    super();
    if (name) {
      this.name = name;
    }
  }
}
